/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

export default function Loader({ styles = {}, ...childProps }) {
  return (
    <FontAwesomeIcon
      icon={faSpinnerThird}
      spin
      style={{
        '--fa-primary-color': 'rgba(234, 88, 12, 1)',
        '--fa-primary-opacity': 1,
        ...styles,
      }}
      {...childProps}
    />
  );
}

Loader.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  styles: PropTypes.object,
};
